export default {
  // baseUrl: 'http://192.168.5.201:8082',
  // downloadUrl: 'http://192.168.5.201:8080/'

  baseUrl: 'http://117.74.136.106:13311/', // 生产
  downloadUrl: 'http://117.74.136.106:11137/'// 生产
}
